<template>
  <div class="clue-table">
    <a-table
      v-if="newList && newList.length"
      ref="clueTable"
      :columns="columns"
      :data-source="newList"
      :pagination="false"
      row-key="id"
      :custom-row="customRow"
    >
      <div
        slot="clue_status"
        slot-scope="text, record"
        class="clue-status-td"
      >
        <a-popover
          v-if="record.followlog.length>0"
          title=""
          trigger="hover"
          overlay-class-name="clue-follow-log-list"
          placement="bottom"
          :arrow-point-at-center="true"
          :destroy-tooltip-on-hide="true"
        >
          <template slot="content">
            <p
              v-for="(item,index) in record.followlog"
              :key="index"
            >
              {{ item }}
            </p>
          </template>
          <span
            class="status_tag"
            :class="record.status ? `status${record.status}`: childStatus(text.status_title)"
          >{{ text }}</span>
        </a-popover>
        <span
          v-else
          class="status_tag"
          :class="record.status ? `status${record.status}`: childStatus(text.status_title)"
        >{{ text }}</span>
        <span
          v-if="record.status === -3"
          class="question-follow"
        > [疑似无效]</span>
      </div>
      <div
        slot="follow_date"
        slot-scope="text,record"
        class="clue-follow"
        :class="{'status-overtime': text.status*1 ===3, 'clue-follow-box': !!record.hover }"
      >
        {{ text.time }}
        <a-button
          v-if="record.is_follow*1 ===1 &&(userid=== record.dev_userid)"
          href="javascript:;"
          class="clue-follow-btn"
          @click.prevent="handlerDetail(text, record, 'follow')"
        >
          完成跟进
        </a-button>
      </div>
      <template
        slot="action"
        slot-scope="text, record"
      >
        <a

          href="javascript:;"
          class="clue-info-link"
          @click="handlerDetail(text, record, 'clueInfo')"
        >详情</a>
        <a-dropdown
          v-if="(userid * 1 === record.dev_userid * 1) || (record.status * 1 === 2)"
          :overlay-style="{'z-index': 1052}"
        >
          <a
            class="ant-dropdown-link clue-tool-link"
            href="javascript:;"
          >
            <span class="truename-text">更多</span>
            <i class="iconfont iconicon-test19 arrow-icon" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-if="(record.status * 1 === 1 || record.status * 1 === 3 ||record.status * 1 === -3) &&(userid=== record.dev_userid)">
              <a

                href="javascript:;"
                @click="handlerDetail(text, record, 'sign')"
              >标记无效</a>
            </a-menu-item>
            <a-menu-item v-if="(record.status * 1 === 1 || record.status * 1 === 3 || record.status * 1 === -3||record.status * 1 === -1 || record.status * 1 === -2)&&(userid=== record.dev_userid)">
              <a

                href="javascript:;"
                @click="handlerDetail(text, record, 'create')"
              >转为信息</a>
            </a-menu-item>
            <a-menu-item v-if="(record.status * 1 === -1 || record.status * 1 === -2)&&(userid=== record.dev_userid)">
              <a

                href="javascript:;"
                @click="handlerDetail(text, record, 'repeatFollow')"
              >重新跟进</a>
            </a-menu-item>
            <a-menu-item v-if="record.status * 1 === 2 && !!record.inquiryid">
              <a
                href="javascript:;"
                @click="toInquryInfo(record)"
              >查看信息</a>
            </a-menu-item>
            <a-menu-item v-if="userid=== record.dev_userid && !!cluePremissionData.enableDel">
              <a
                href="javascript:;"
                @click="handleDelete(record)"
              >删除线索</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>
    </a-table>
    <a-spin
      v-else-if="searched && loading"
      class="spin-fixed-center"
    />
    <pagination
      v-if="newList && newList.length"
      ref="pagination"
      :pagination="pagination"
      @change="handlePage"
    />
    <div
      v-show="searched && !loading && (!list || !list.length)"
      class="empty-box"
    >
      <i class="iconfont iconicon-test38 logo" />
      <p class="placeholder">
        查询无结果，可录入一条新线索
      </p>

      <a-button
        v-if="!!cluePremissionData.enableAdd"
        type="primary"
        @click="onClickAdd"
      >
        录入线索
      </a-button>
    </div>
    <!-- 完成跟进弹窗 -->
    <follow-modal
      :data="{clueid: itemData.id, id: itemData.follow_date && itemData.follow_date.follow_id || ''}"
      :follow-data="{field: followLogs.next_follow_field || '', value: followLogs.next_follow_value || '', time: followLogs.next_followup_time || ''}"
      :visible.sync="isShowFollowModal"
      @finishHandle="finishHandle"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Pagination from '@/components/pc/Pagination'
import FollowModal from './FollowModal'

export default {
  components: {
    Pagination,
    FollowModal
  },
  props: {
    /* searched: {
      type: Boolean,
      default: false
    }, */
    follow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShowFollowModal: false,
      itemData: {}
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapState('inquery/clue', [
      'loading',
      'searched',
      'searchConfig',
      'list',
      'pagination',
      'followLogs',
      'cluePremissionData'
    ]),
    ...mapGetters('inquery/clue', [
      'newList',
      'columns'
    ]),
    pid () {
      return this.$route.params.pid
    },
    userid () {
      const { userid = '' } = this.baseinfo
      return userid + ''
    }
  },
  watch: {
    newList: {
      handler (val) {
        // this.expandedRowKeys = this.rowKeys
      },
      deep: true
    },
    $route: {
      handler (val) {
        // const { page = 1 } = val.query.page
        this.pagination.currentPage = val.query.page * 1 || 1
      },
      immediate: true
    }
  },
  created () {
  },
  methods: {
    ...mapActions('inquery/clue', ['fetchClueDatas', 'finishFollow', 'fetchFollowLog', 'finishSign', 'repeatFollowClue', 'delClue']),
    async handlePage (pagination) {
      this.pagination.currentPage = pagination.currentPage
      this.$router.push({
        name: 'InqueryClue',
        query: {
          ...this.$route.query,
          page: pagination.currentPage,
          limit: pagination.pageSize,
          _t: new Date().getTime()
        }
      })
      await this.fetchClueDatas({
        ...this.$route.query,
        page: pagination.currentPage,
        limit: pagination.pageSize
      })
      // this.getRepeatList()
    },

    async handlerDetail (text, record, type) {
      const { tempid: id } = record
      const { query } = this.$route
      let chain = null
      if (type === 'follow') {
        this.itemData = record
        chain = await this.fetchFollowLog({ clueid: id })
        chain.onSuccess(raw => {
          this.isShowFollowModal = true
        })
        // this.isShowFollowModal = true
      } else if (type === 'sign') {
        chain = await this.finishSign(query)
        chain.params({ id, clueid: id }).fetch()
      } else if (type === 'clueInfo') {
        this.$router.push({
          path: `/project/${this.pid}/clue/detail/${id}`,
          query: { ...this.$route.query, from: 'clue' }

        })
      } else if (type === 'create') {
        this.$router.push({
          path: `/project/${this.pid}/inquery/create`,
          query: {
            clue_id: id,
            from: 'clue'
          }
        })
      } else if (type === 'repeatFollow') {
        chain = await this.repeatFollowClue(query)
        chain.params({ id, clueid: id }).fetch()
      }
    },
    toInquryInfo (item) {
      this.$router.push({
        // path: `/project/${this.pid}/inquery/detail/${inquiryid}`,
        name: item.inquiry_status * 1 === 1 ? 'InqueryPassDetail' : 'InqueryDetail',
        params: {
          pid: this.pid,
          inquiryId: item.inquiryid
        },
        query: {
          from: 'clue',
          clue_id: item.id
        }
      })
    },
    customRow (record) {
      return {
        on: {
          mouseenter: (event) => {
            // this.$set(record, 'hover', true)
            event.target.className = event.target.className + ' ' + 'clue-follow-box'
            // this.$forceUpdate()
          },
          mouseleave: (event) => {
            // this.$set(record, 'hover', false)
            let clueClassName = event.target.className
            if (clueClassName.indexOf('clue-follow-box') > -1) {
              event.target.className = clueClassName.replace('clue-follow-box', '')
            }
          }
        }
      }
    },
    onClickAdd () {
      this.$router.push({
        name: 'ClueCreate'
      })
    },
    childStatus (str) {
      let statusClass = 'status1'
      switch (str) {
        case '任务超时':
          statusClass = 'status3'
          break
        case '无效（无法联系）':
        case '无效（人工确定）':
          statusClass = 'status-1'
          break
        case '已转为信息':
          statusClass = 'status2'
          break
        case '等待中':
          statusClass = 'status4'
          break
        default:
          statusClass = 'status1'
      }
      return statusClass
    },
    async finishHandle () {
      await this.fetchClueDatas({
        ...this.$route.query
      })
    },
    /**
     * 删除线索
     */
    async handleDelete (record) {
      this.$confirm({
        title: '删除线索',
        content: '删除后不可恢复，是否继续？',
        closable: true,
        okText: '确定',
        okType: 'primary',
        cancelText: '取消',
        class: 'confirm-warn-modal',
        onOk: async () => {
          const chain = await this.delClue({ ...this.$route.query, page: 1 })
          chain.params({ clueid: record.id })
            .onSuccess(raw => {
              this.pagination.currentPage = 1
              this.$router.push({
                name: 'InqueryClue',
                query: {
                  ...this.$route.query,
                  page: 1
                }
              })
            })
            .fetch()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

::v-deep .ant-table-placeholder {
  display: none;
}
.empty-box {
  text-align: center;
  .logo {
    display: block;
    margin: 40px auto 8px;
    font-size: 24px;
    color: #d6d6d6;
  }
  .placeholder {
    margin-bottom: 16px;
    color: $gray3;
  }
}
.clue-table::v-deep{
  .ant-table-thead > tr > th, .ant-table-tbody > tr > td{
    padding: 12px 10px;
  }
  // .ant-table-row-expand-icon {
  //   background: #4CA0F2;
  //   border-radius: 2px;
  //   border: 0 none;
  //   color: #fff;
  //   font-size: 16px;
  // }
  // .ant-table-row-level-1 {
  //   background: #f5f6f7;
  //   color: #666;
  //   }
  // .ant-table-scroll {
  //   .ant-table-row-level-1 {
  //   td:first-child{
  //     padding-left: 40px;
  //   }
  //   td:first-child > span.indent-level-1, td:first-child >.ant-table-row-spaced.ant-table-row-expand-icon {
  //     // padding-left: 0 !important;
  //     display: none;
  //   }

  // }
  // }
  .clue-status-td{
    white-space: nowrap;
  }
  .question-follow{
    color:#4ca0f2;
    font-size: 12px;
  }
  .clue-info-link{
    margin-right: 10px;
  }
  .clue-tool-link {
    color: #5077aa;
    .iconicon-test19 {
      font-size: 13px;
    }
  }
  .status_tag ,.status-3 {
  position: relative;
  background: #fff;
  font-size: 12px;
  box-sizing: border-box;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  padding: 2px 6px 2px 14px;
  color:#4CA0F2;
  font-size: 12px;
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 4px;
    transform: translateY(-50%);
    width: 4px;
    height: 4px;
    border-radius: 50%;
   background: #4CA0F2
  }
}
  .status2 {
    color: #42C27E;
    &::before{
      background:#42C27E ;
    }
  }
  .status3 {
    color: #F6A953;
    &::before{
      background:#F6A953 ;
    }
  }
  .status-1, .status-2 {
    color: #999;
    &::before{
      background:#999;
    }
  }
  .status4 {
    color:#333;
    &::before{
      background:#999;
    }
  }
  .status-overtime{
    color: #F57676;
  }
  // .clue-status-td {
  //   min-width: 220px;
  // }
}
.clue-follow{
  position: relative;

}
.clue-follow-btn{
    position: absolute;
    right:-20px;
    z-index: 3;
    top: -4px;
    display: none;
  }
.clue-follow-box{
    .clue-follow-btn{
      display: inline-block
    }

  }

</style>
<style lang="scss">
  .clue-follow-log-list{
    p{
      font-size: 12px;
      line-height: 20px;
    }
  }
</style>
